import { GeoJsonLayer } from "@deck.gl/layers";
import FishIcon from "../../icons/fish.svg";
export type Route = { features: any[] }

export function getRouteLayer(routeData: Route, darkMode: boolean): GeoJsonLayer<Route>[] {
  // const startingPoint = { ...routeData, features: routeData.features.filter(f => f.properties.start) };
  // const endPoint = { ...routeData, features: routeData.features.filter(f => f.properties.end) };

  // Remove start and end points, because we dont want to display them as fishing spots
  const routeDataWithFishingSpots = { ...routeData, features: routeData.features.filter(f => !(f.properties.start || f.properties.end)) };

  return [
    new GeoJsonLayer({
      id: 'route',
      data: routeDataWithFishingSpots,
      pickable: true,
      autoHighlight: true,
      lineWidthMinPixels: 4,
      getLineColor: darkMode ? [200, 255, 200, 230] : [32, 42, 68, 240],
      highlightColor: [100, 100, 100, 180],

      pointType: 'icon',
      getIcon: () => ({ id: "FishIcon", url: FishIcon, width: 128, height: 128 }),
      iconSizeMaxPixels: 60,
      // iconSizeMinPixels: 22,
      iconSizeUnits: "common",
      getIconSize: 1.0,
      iconAlphaCutoff: 0,
      // iconBillboard: false,
      getIconColor: [0, 0, 0, 255],
      parameters: {
        depthTest: false
      },
    })
  ]
}
